import { useEffect, useState } from 'react';
import * as _ from 'lodash-es';
import { modules } from '../../constants';
import { getAreasMap, getPropertyTypes } from '../../service/mlsInfo';
import { useSearchStore } from '../../store/store';
import { getOfficesByModule } from '../helpers/search';

export const useMls = (mlsId, selectedModule, options = {}) => {
    const [propTypes, setPropTypes] = useState({});
    const [mappedAreas, setMappedAreas] = useState({});
    const [offices, setOffices] = useState({});
    const { isSilentLoad  = false } = options;

    const setIsLoading = useSearchStore(state => state.setIsLoading);

    const fetchMlsProperties = async (mlsId, selectedModule) => {
        if (mlsId && selectedModule) {
            //propTypes
            //every module except offices
            if (!propTypes[mlsId] && selectedModule !== modules.proficiencyMetrics.offices) {
                const propertyTypesResponse = await getPropertyTypes(mlsId);
                if (!propertyTypesResponse.error) {
                    const sorted = _.sortBy(propertyTypesResponse, [o => o.classId]);
                    _.forEach(sorted, o => o.types = _.sortBy(o.types, [t => t.typeId]));
                    setPropTypes({
                        ...propTypes,
                        [mlsId]: sorted
                    });
                }
            }

            //areasMap
            //every module
            if (!mappedAreas[mlsId]) {
                const mappedAreasResponse = await getAreasMap(mlsId);
                if (!mappedAreasResponse.error) {
                    setMappedAreas({
                        ...mappedAreas,
                        [mlsId]: mappedAreasResponse
                    });
                }
            }

            //offices
            if (!offices[mlsId] && [
                modules.proficiencyMetrics.offices,
                modules.marketShare.coverage,
                modules.proficiencyMetrics.agentMovement].includes(selectedModule)) {
                const officesResponse = await getOfficesByModule(mlsId)[selectedModule]();
                if (!officesResponse.error) {
                    setOffices({
                        ...offices,
                        [mlsId]: officesResponse
                    });
                }
            }
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            if (!isSilentLoad) setIsLoading(true);
            if (mlsId && selectedModule) {
                await fetchMlsProperties(mlsId, selectedModule);
            }
            if (!isSilentLoad) setIsLoading(false);
        };
        fetchData();
    }, [mlsId, selectedModule]);

    return {
        propTypes: mlsId && propTypes[mlsId],
        mappedAreas: mlsId && mappedAreas[mlsId],
        offices: mlsId && offices[mlsId]
    };
};
